import { Component, Input, Output, EventEmitter, DoCheck } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { Service } from '../org-vdc-wizard.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
import { State } from '@clr/angular';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'sddc-pool',
  providers: [
    Service, TranslateService
  ],
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./sddc-pool.html')
})

export class SddcPool  {
  @Input('isVisible') isVisible: boolean;
  @Input() descVdcData: any;

  @Input() orgVdcId: string = '';
  @Input() editData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private sddcClassName: string = '';
  private subscribeHandler;
  private isTranslationready: boolean = true;
  private selectedOrgPrevious: String;
  private pVDCList: Array<any> = [];
  private loading: boolean = false;
  private selected = [];
  private isFirstLoad: boolean = false;
  private result: any;
  private providerVDCId: string = '';
  private dataModel = {
    selectedSDDC: [],
    isStepValid: false,
    pVDC: [],
    stepId: -1
  };

  ngDoCheck() {
  }

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private alert: VcaAlertsService) {
    translate.use(GlobalVariables.LOCALE);
    this.resetStep();
  }

  resetStep() {
    this.dataModel = {
        selectedSDDC: [],
        isStepValid: false,
        pVDC: [],
        stepId: -1
    };
    this.loading =  false;
    this.selected = [];
    this.isFirstLoad = false;
    this.pVDCList = [];
  }

  reset() {
    this.dataModel.selectedSDDC = [];
    this.dataModel.isStepValid = false;
    this.dataModel.stepId = -1;
    this.selected = [];
    this.loading = false;
    this.isFirstLoad = false;
  }

  ngOnChanges(changes) {
    if ( !this.isWizardOpen ) {
      this.reset();
      return;
    }
    $('.datagrid-column-title .checkbox').hide();
    if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
    }
    if (this.descVdcData && this.descVdcData.selectedOrgId) {
      if (!this.selectedOrgPrevious ||
          (this.selectedOrgPrevious !== this.descVdcData.selectedOrgId)) {
            this.selectedOrgPrevious = this.descVdcData.selectedOrgId;
            this.loading = true;
            this.getPVdcs();
      }
    }
  }

  ngOnDestroy() {
    if (this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  getPVdcs() {
    this.subscribeHandler = this.service.getPVdcs()
      .subscribe(
        (result: any) => {
          this.result = result;
          this.dataModel.pVDC = result;
          this.processData(this.result);
          this.isFirstLoad = false;
        },
        error => {
          this.service.logError(error, 'get SDDC Pool');
          this.alert.danger([error], 'sddc-pool');
        },
        () => this.service.logOperationCompleted('get SDDC Pool completed')
      );
  }

  processData(result: any) {
    this.pVDCList = [];
    if (!result) {
        return;
    }

    for (let i = 0; i < result.length; i++) {
      let row = {};
      let data = result[i];

      row['name'] = data.name;
      row['cpu'] = (data.cpu.units === "MHz") ? data.cpu.total / 1024 : data.cpu.total;
      row['memory'] = (data.memory.units === "MB") ? data.memory.total / 1024 : data.memory.total;

      let storageTotal = 0;
      for (let j = 0; j < data.storageProfiles.length; j++) {
          storageTotal += (data.storageProfiles[j].units === "MB") ? (data.storageProfiles[j].capacityTotal / 1024) : data.storageProfiles[j].capacityTotal;
      }

      row['cpu'] = row['cpu'].toFixed(2);
      row['memory'] = row['memory'].toFixed(2);
      row['storageProfiles'] = storageTotal.toFixed(2);
      row['iopsEnabled'] = (data.iopsEnabled) ? data.iopsEnabled : 'false';
      row['objectId'] = data.objectId;
      this.pVDCList.push (row);
    }
    this.loading = false;
  }

  refresh(state) {
  }

  private onSelectedChanged(event: any): void {
    if (!this.isFirstLoad) {
        this.isFirstLoad = true;
    }
    if (event.length === 0) {
        return;
    }

    if (this.selected.length === 2) {
        this.selected = [event[1]];
        this.dataModel.selectedSDDC = this.selected;
    } else if (this.selected.length === 1)  {
        this.dataModel.selectedSDDC = [event[0]];
    }
    this.dataModel.isStepValid = true;
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/steps/sddc-pool.component.ts